module.exports = __webpack_public_path__ + "img/logo-m2n.a0c2f145.svg";